// @flow

import * as React from 'react';
import './ResultData.scss';

type Props = {
  type: string,
  data: string,
  other: ?string,
  dataFont: number
}

const ResultData = ({
  type = '--', data = '--', other, dataFont = 12,
}: Props) => {
  const style = {
    fontSize: `${dataFont}px`,
  };

  return (
    <div className="result-data">
      <div className="result-data--type">{ type }</div>
      <div className="result-data--data">
        <span style={style} className="result-data--data-number">{ data }</span>
        { other && (<span className="result-data--data-other">{ other }</span>) }
      </div>
    </div>);
};

ResultData.defaultProps = {
  other: null,
};

export default ResultData;
